import { useMemo } from 'react';

import { useFacilityMenuGet } from '../services/facility';
import { transformToMenuAndSubMenu } from '../utils/transform';

export const useFacilityMenuItems = () => {
  const { data, ...rest } = useFacilityMenuGet();
  const parentMenuWithSubMenuItemsType = useMemo(
    () => transformToMenuAndSubMenu(data ?? []),
    [data]
  );
  return {
    allMenuItems: data,
    parentMenuWithSubMenuItemsType,
    ...rest,
  };
};
